import React, { useState } from 'react';

export default function AppDrawer({ open, onClose, apps, onOpenWindow }) {
  const [search, setSearch] = useState('');
  const filtered = apps.filter(a => a.title.toLowerCase().includes(search.toLowerCase()) || a.url.toLowerCase().includes(search.toLowerCase()));

  if (!open) return null;

  return (
    <div className="app-drawer-backdrop" onMouseDown={onClose}>
      <div className="app-drawer" onMouseDown={e => e.stopPropagation()}>
        <div className="app-drawer-header">
          <h2>Applications</h2>
          <input className="search" placeholder="Rechercher..." value={search} onChange={e => setSearch(e.target.value)} />
          <button className="icon-btn" onClick={onClose}>✕</button>
        </div>
        <div className="app-drawer-grid">
          {filtered.map(a => (
            <div key={a.id} className="app-drawer-item" onClick={() => { onOpenWindow(a); onClose(); }}>
              <img src={a.icon || (a.url ? (new URL(a.url).origin + '/favicon.ico') : '/favicon.ico')} onError={(e)=> e.currentTarget.src='/favicon.ico'} />
              <span>{a.title}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
